import { Link } from 'react-router-dom';
import styled from 'styled-components';

import { Color } from '../../enums';
import { StyledComponent } from '../../interfaces';
import { Icon } from '../icon/icon.component';

import { BreadcrumbItemProps } from './breadcrumbs.types';

export const Container: StyledComponent<'div'> = styled.div`
  display: flex;
  align-items: center;
`;

export const BreadcrumbItem: StyledComponent<typeof Link, BreadcrumbItemProps> = styled(Link)<BreadcrumbItemProps>`
  font-size: 12px;
  line-height: 16px;
  color: ${({ $active }: BreadcrumbItemProps): Color => $active ? Color.Black : Color.Gray500};
  pointer-events: ${({ $active }: BreadcrumbItemProps): string => $active ? 'none' : 'initial'};
`;

export const BreadcrumbLinkWithIcon: StyledComponent<typeof Link> = styled(Link)`
  display: flex;
  align-items: center;

  ${BreadcrumbItem} + &,
  & + ${BreadcrumbItem} {
    margin-left: 12px;
  }
`;

export const StyledIcon: StyledComponent<typeof Icon> = styled(Icon)`
  ${BreadcrumbItem} + &,
  & + ${BreadcrumbItem} {
    margin-left: 12px;
  }
`;
